import { render, staticRenderFns } from "./Tabnav.vue?vue&type=template&id=5d1eea76&"
import script from "./Tabnav.vue?vue&type=script&lang=js&"
export * from "./Tabnav.vue?vue&type=script&lang=js&"
import style0 from "./Tabnav.vue?vue&type=style&index=0&id=5d1eea76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports